import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const StrongCTA = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/919167176555', '_blank');
  };

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-black via-zinc-900 to-black relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-yellow-600 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-yellow-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Positioning Statement */}
        <div className="mb-16">
          <h2 className="heading-font text-3xl md:text-5xl font-bold text-white mb-8 leading-tight">
            We don't just manage events.
          </h2>
          <p className="heading-font text-2xl md:text-4xl gold-accent font-light leading-relaxed">
            We design evenings your audience will remember long after the event ends.
          </p>
        </div>

        <div className="w-32 h-1 gold-bg mx-auto mb-12"></div>

        {/* CTA Content */}
        <div className="bg-zinc-800 p-12 rounded-sm border-2 border-yellow-600">
          <h3 className="heading-font text-2xl md:text-3xl font-bold text-white mb-6">
            Let's Create an Unforgettable Evening for Your Event
          </h3>
          <p className="body-font text-lg text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto">
            If you're planning an event and want an evening that feels premium, engaging, and flawlessly executed—we'd love to collaborate.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button 
              onClick={scrollToContact}
              className="gold-bg text-black hover:bg-yellow-600 px-10 py-6 text-lg font-bold body-font rounded-sm shadow-2xl flex items-center gap-3"
            >
              <Phone size={22} />
              Schedule a Call
            </Button>
            <Button 
              onClick={openWhatsApp}
              className="bg-green-600 hover:bg-green-700 text-white px-10 py-6 text-lg font-bold body-font rounded-sm shadow-2xl flex items-center gap-3"
            >
              <MessageCircle size={22} />
              Connect on WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrongCTA;
